/**
 * Present on the DOM node that displays the agency name (for find scroll).
 * Value is the AgencyID string.
 */
export const AGENCY_TREE_TITLE_DATA_ATTR = 'data-agency-tree-title';

/**
 * Outline for the current find-match (Cmd+F style). Applied imperatively via
 * `classList` by useAgencyTreeFind so typing in the find box does not
 * re-render the (potentially huge) tree. Drawn inset (negative offset)
 * because the scroll container clips anything painted outside the row.
 */
export const ACTIVE_FIND_RING_CLASSES = [
  'outline',
  'outline-2',
  'outline-primary',
  '-outline-offset-2',
  'rounded-[10px]'
];

/**
 * props for the node rendering an agency name, so find can scroll to it
 * @param agencyId - the agency the node represents
 */
export function agencyTitleAnchorProps(agencyId) {
  return { [AGENCY_TREE_TITLE_DATA_ATTR]: agencyId };
}

/**
 * props for the list item wrapping an agency row, so find can highlight it
 * @param agencyId - the agency the row represents
 */
export function agencyRowListProps(agencyId) {
  return { 'data-agency-id': agencyId };
}
